// extracted by mini-css-extract-plugin
export var attachButton = "_cg-8";
export var sendButton = "_cg-2";
export var sendDisabled = "_cg-4";
export var sendEnabled = "_cg-3";
export var sendIcon = "_cg-6";
export var sendIconDisabled = "_cg-7";
export var sendStreaming = "_cg-5";
export var textarea = "_cg-1";
export var wrapper = "_cg-0";